<span>
    <button
        mat-icon-button
        [attr.aria-label]="
            hasNotifications()
                ? ('shared.skeleton.notifications.openBtnLabel' | translate) +
                  '. ' +
                  ('shared.skeleton.notifications.numOfNotifIsWithCount'
                      | translate: { count: notificationCount() })
                : ('shared.skeleton.notifications.openBtnLabel' | translate)
        "
        (click)="dialogOpen.emit()">
        <p-overlaybadge
            class="notifications-overlay-badge"
            [value]="notificationCount()"
            severity="danger"
            badgeSize="small"
            [badgeDisabled]="!hasNotifications()">
            <mat-icon
                [fontIcon]="
                    notificationCount() > 0
                        ? 'notifications_on'
                        : 'notifications'
                "></mat-icon>
        </p-overlaybadge>
    </button>
</span>
